// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PageBaseLayout-module-main-f0twr{position:relative}.PageBaseLayout-module-container-zQX9G{display:grid;align-items:flex-start;grid-gap:20px;gap:20px}@media(min-width: 960px){.PageBaseLayout-module-container-zQX9G.PageBaseLayout-module-withAside-Fwayr{grid-template-columns:1fr 380px}}.PageBaseLayout-module-orderExceptionVisible-tjUae{filter:blur(3px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "PageBaseLayout-module-main-f0twr",
	"container": "PageBaseLayout-module-container-zQX9G",
	"withAside": "PageBaseLayout-module-withAside-Fwayr",
	"orderExceptionVisible": "PageBaseLayout-module-orderExceptionVisible-tjUae"
};
export default ___CSS_LOADER_EXPORT___;
